<template>
  <VueFinalModal
    v-model="isVisible"
    class="confirm-modal"
    content-class="confirm-modal-content"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
    :click-to-close="false"
    :esc-to-close="false"
  >
    <slot name="title">
      <h3 class="modal-title text-muted">{{ title }}</h3>
    </slot>

    <slot name="body">
      <component
        :is="dynamicComponent"
        v-bind="componentProps"
        @submit="handleConfirm"
        @cancel="handleCancel"
      />
    </slot>
  </VueFinalModal>
</template>

<script>
import { VueFinalModal } from "vue-final-modal";

export default {
  name: "GlobalModal",
  components: { VueFinalModal },
  data() {
    return {
      isVisible: false,
      title: "Modal",
      dynamicComponent: null,
      componentProps: {},
      onConfirm: () => {},
      onCancel: () => {},
    };
  },
  methods: {
    open({ title, component, props, onConfirm, onCancel }) {
      this.title = title || "Modal";
      this.dynamicComponent = component;
      this.componentProps = props || {};
      this.onConfirm = onConfirm || (() => {});
      this.onCancel = onCancel || (() => {});
      this.isVisible = true;
    },
    close() {
      this.isVisible = false;
      this.dynamicComponent = null;
      this.componentProps = {};
      this.onConfirm = () => {};
      this.onCancel = () => {};
    },
    handleConfirm(payload) {
      this.onConfirm(payload);
    },
    handleCancel() {
      this.onCancel();
      this.isVisible = false;
    },
  },
};
</script>

<style scoped>
.modal-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1.25rem;
}
</style>
